jQuery(function ($) {

	// Open/Close sites list
	$("[data-js=open-sites]").on("click", function () {
		$(this).closest(".plugin-installs").toggleClass("opened");
	});

	// Handle selected version
	$("[data-js=product-version]").on("change", function (e) {
		// Get parent wrapper
		let parent = $(this).parent().parent();

		// Get current selected option
		let element = $(this).find("option:selected");

		// Get selected option release date
		let download_release = element.attr("data-download-release");

		// Get selected option download url
		let download_url = element.attr("data-download-url");

		// Update Released version
		parent.find(".release_date").html(download_release);

		// Updated download button URL
		parent.find(".button--download").attr("href", download_url);
	});

	// Handle remove install
	$("[data-js=remove-install]").on("click", function (e) {
		let installRow = $(this).closest(".plugin-install-site");

		// Clear notices alert
		$(".woocommerce-notices-wrapper").fadeOut(600);

		// license-key
		let license_key = $(this).data("license-key");

		// install-domain
		let install_domain = $(this).data("install-domain");

		// Ensure we have a license key and install domain
		if (license_key === undefined || install_domain === undefined) {
			return;
		}

		// Ask for confirmation
		if (confirm("Are you sure you want to remove this install?")) {

			//Remove install
			$.ajax({
				url: stellarCommerce.ajaxUrl,
				type: "POST",
				data: {
					action: "stellarwp_commerce_uplink_remove_install",
					nonce: stellarCommerce.nonce,
					license_key: license_key,
					install_domain: install_domain
				},
				success: function (response) {
					if (response.success) {
						// Remove install row
						installRow.remove();
						if (response.data.message) {
							$('.woocommerce-notices-wrapper').html('<div class="woocommerce-message" role="alert">' + response.data.message + '<button type="button" class="close-button material-icons close-notices" aria-label="Close">&#xe5cd;</button></div>').show();
						}
					} else {
						if (response.data.message) {
							$('.woocommerce-notices-wrapper').html('<div class="woocommerce-error" role="alert">' + response.data.message + '<button type="button" class="close-button material-icons close-notices" aria-label="Close">&#xe5cd;</button></div>').show();
						} else {
							$('.woocommerce-notices-wrapper').html('<div class="woocommerce-error" role="alert">Something went wrong. Please try again or contact customer support.<button type="button" class="close-button material-icons close-notices" aria-label="Close">&#xe5cd;</button></div>').show();
						}
					}
				},
				error: function (response) {
					$('.woocommerce-notices-wrapper').html('<div class="woocommerce-error" role="alert">Something went wrong. Please try again or contact customer support.<button type="button" class="close-button material-icons close-notices" aria-label="Close">&#xe5cd;</button></div>').show();
				}
			});
		}
	});

});
